// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { DocumentReminder } from "le-coffre-resources/dist/Notary";
import type { QueryPayload } from "../../../types";

interface DocumentRemindersHistoryInstance {
	get(query?: QueryPayload): Promise<DocumentReminder[]>;
	count(query?: QueryPayload): Promise<{ count: number }>;
}

// Module-level singleton instance
let instance: DocumentRemindersHistoryInstance | null = null;
let baseNotaryInstance: IBaseNotary | null = null;

function createDocumentRemindersHistory(): DocumentRemindersHistoryInstance {
	if (!baseNotaryInstance) {
		baseNotaryInstance = createBaseNotary();
	}

	const baseNotary = baseNotaryInstance;
	const baseUrl = baseNotary.namespaceUrl.concat("/document_reminders");

	return {
		get: async (query?: QueryPayload): Promise<DocumentReminder[]> => {
			const url = new URL(baseUrl);
			if (query) {
				baseNotary.appendJsonSearchParams(url, { q: query });
			}
			try {
				return await baseNotary.getRequest<DocumentReminder[]>(url);
			} catch (err) {
				baseNotary.onError(err);
				return Promise.reject(err);
			}
		},
		count: async (query?: QueryPayload): Promise<{ count: number }> => {
			const url = new URL(baseUrl.concat("/count"));
			if (query) {
				baseNotary.appendJsonSearchParams(url, { q: query });
			}
			try {
				return await baseNotary.getRequest<{ count: number }>(url);
			} catch (err) {
				baseNotary.onError(err);
				return Promise.reject(err);
			}
		},
	};
}

export function getDocumentRemindersHistoryInstance(): DocumentRemindersHistoryInstance {
	if (!instance) {
		instance = createDocumentRemindersHistory();
	}
	return instance;
}
